export const goTop = () => {
  window.scrollTo({ top: 0 });
};
